<div class="alert alert-info" ng-show="vm.numCC === 0">
    <h4><i class="fa fa-info-circle"></i>&nbsp;Es wurden noch keine Konsultationen abgeschlossen</h4>
</div>


<!--<div class="alert alert-info" role="button" ng-click="vm.$log.debug('div clicked')">
    <h4><i class="fa fa-info-circle"></i>&nbsp;Click-Test: wann reagiert das panel, und wann der button?</h4>
    <div class="btn btn-success" ng-click="vm.$log.debug('inner button clicked');$event.stopPropagation()">Click me!
    </div>

</div>
<div class="btn btn-success" ng-click="vm.$log.debug('outer button clicked')">Click me!</div>-->

<div ng-repeat="cons in vm.consults  | orderBy: '-created'| filter: {open: false} track by $index"
     class="panel panel-default">
    <div class="panel panel-heading" style="margin-bottom: 0px" role="button" ng-click="vm.togglePanel($index, cons)">
        <consultsummary consult="cons"></consultsummary>
    </div>
    <div class="panel panel-body" ng-show="vm.display[$index]">
        <h4 ng-show="cons.symptoms">Symptome</h4>
        <p ng-show="cons.symptoms">{{cons.symptoms}}</p>
        <h4 ng-show="cons.therapy">Therapie</h4>
        <p ng-show="cons.therapy">{{cons.therapy}}</p>
        <h4 ng-show="cons.diagnoses">Diagnosen</h4>
        <p ng-show="cons.diagnoses">{{cons.diagnoses}}</p>
        <div ng-show="cons.documents.length > 0">
            <h4>Dokumente</h4>
            <documentlist documents="cons.documents"></documentlist>
        </div>
        <div ng-show="cons.examinations.length > 0">
            <h4>Untersuchungen</h4>
            <consultexamlist examinations="cons.examinations"></consultexamlist>
        </div>
        <div ng-show="cons.images.length > 0">
            <h4>Bilder</h4>
            <imageviewer images="cons.images"></imageviewer>
        </div>
        <div ng-show="cons.files.length > 0">
            <h4>Dateien</h4>
            <filelist files="cons.files"></filelist>
        </div>
    </div>
</div>

<!--

<uib-accordion close-others="oneAtATime">
    <div uib-accordion-group heading="{{group.title}}" class="panel-default"
         ng-repeat="cons in vm.consults  | filter: {open: false } | orderBy: '-created'">
        <uib-accordion-heading class="">
            <consultsummary consult="cons"></consultsummary>
        </uib-accordion-heading>


        <h4 ng-show="cons.symptoms">Symptome</h4>
        <p ng-show="cons.symptoms">{{cons.symptoms}}</p>
        <h4 ng-show="cons.therapy">Therapie</h4>
        <p ng-show="cons.therapy">{{cons.therapy}}</p>
        <h4 ng-show="cons.diagnoses">Diagnosen</h4>
        <p ng-show="cons.diagnoses">{{cons.diagnoses}}</p>
        <h4>Anmerkungen</h4>
        {{cons.comments}}
        <div>
            &lt;!&ndash; Dokumente einblenden &ndash;&gt;
            <button class="btn btn-primary" ng-hide="cons.docs" ng-click="vm.getDocuments(cons)">Dokumente einblenden
            </button>
            <button class="btn btn-primary" ng-show="cons.docs" ng-click="cons.docs = null">Dokumente ausblenden
            </button>
            &lt;!&ndash; Untersuchungen einblenden &ndash;&gt;
            <span>
        <button class="btn btn-primary" ng-hide="cons.exams" ng-click="vm.getExams(cons)">
          Untersuchungen einblenden
        </button>
        <button class="btn btn-primary" ng-show="cons.exams" ng-click="cons.exams = null">
          Untersuchungen ausblenden
        </button>
      </span>
            &lt;!&ndash; Bilder einblenden &ndash;&gt;
            <span ng-show="cons.images.length > 0 ">
        <button class="btn btn-primary" ng-hide="cons.imgs" ng-click="cons.imgs = 1">
            Bilder der Konsultation einblenden
        </button>
        <button class="btn btn-primary" ng-show="cons.imgs" ng-click="cons.imgs = null">Bilder ausblenden</button>
      </span>

            &lt;!&ndash; Dokumente Block &ndash;&gt;
            <div ng-show="cons.docs">
                <h4>Dokumente (Detail- &amp; Gesamtbefund, Überweisungen, ...)</h4>
                <div class="row" ng-repeat="doc in cons.docs">
                    <div class="col-md-10">{{doc.type}}</div>
                    <div class="col-md-2" style="text-align: right">
                        <a href="/routes/pdfreader/{{doc._id}}" target="_blank" class="btn btn-primary"
                           ng-show="doc._id"><i
                            class="fa fa-eye"></i></a>
                        <a href="/routes/pdfdownload/{{doc._id}}" class="btn btn-primary" ng-show="doc._id"><i
                            class="fa fa-download"></i></a>
                    </div>
                </div>
            </div>

            &lt;!&ndash; Exam Block  &ndash;&gt;
            <div ng-show="cons.exams">
                <h4>Untersuchungen</h4>
                <div class="alert alert-info" ng-show="cons.examinations.length === 0">Keine Untersuchungen gefunden
                </div>
                <div class="row examrow" ng-repeat="exam in cons.examinations">
                    <div class="col-md-9"><strong>{{exam.type}}</strong><br>{{exam.diagnosis}}</div>
                    <div class="col-md-3" style="text-align: right">
                        <a ng-show="exam.files.length > 0 && !eximg" ng-click="eximg = 1" class="btn btn-primary"
                           uib-tooltip="Bilder anzeigen">
                            <i class="fa fa-image"></i>
                        </a>
                        <a ng-show="exam.files.length > 0 && eximg" ng-click="eximg = null" class="btn btn-primary"
                           uib-tooltip="Bilder ausblenden">
                            <i class="fa fa-image"></i>
                        </a>
                        <a ng-show="!exdata" ng-click="exdata = 1" class="btn btn-primary" uib-tooltip="Daten anzeigen">
                            <i class="fa fa-table"></i>
                        </a>
                        <a ng-show="exdata" ng-click="exdata = null" class="btn btn-primary"
                           uib-tooltip="Daten ausblenden">
                            <i class="fa fa-table"></i>
                        </a>
                        &lt;!&ndash; Untersuchungs Befund PDF für includefindings false untersuchungen &ndash;&gt;
                        <a href="/routes/pdfreader/{{exam.docid}}" target="_blank"
                           ng-hide="exam.template.includefindings === true"
                           uib-tooltip="Befund PDF anzeigen" class="btn btn-primary"><i class="fa fa-eye"></i></a>
                        <a href="/routes/pdfdownload/{{exam.docid}}" ng-hide="exam.template.includefindings === true"
                           uib-tooltip="Befund PDF speichern" class="btn btn-primary"><i class="fa fa-download"></i></a>
                        &lt;!&ndash;            &lt;!&ndash; Gesamtbefund für includefindings untersuchungen &ndash;&gt;
                                    <a href="/routes/pdfreader/{{cons.docid}}" target="_blank" ng-show="exam.template.includefindings === true"
                                       uib-tooltip="Befund PDF anzeigen" class="btn btn-primary"><i class="fa fa-eye"></i></a>
                                    <a href="/routes/pdfdownload/{{cons.docid}}" ng-show="exam.template.includefindings === true"
                                       uib-tooltip="Befund PDF speichern" class="btn btn-primary"><i class="fa fa-download"></i></a>&ndash;&gt;
                    </div>
                    &lt;!&ndash; Exam Bilder &ndash;&gt;
                    <div ng-show="eximg" style="padding:20px">

                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
                             ng-click="vm.showImage(img)"
                             ng-repeat="img in exam.files | filter: {mimetype: 'image/jpeg'} |  orderBy: '_id'">

                            <img class="img-responsive" src="/routes/files/filereader/{{img.fileid}}"
                                 uib-tooltip="{{img.label}}">
                        </div>

                    </div>
                    &lt;!&ndash; Exam Daten &ndash;&gt;
                    <div ng-show="exdata" style="padding:20px">

                        <div class="row">
                            <div class="col-xs-12">
                                &lt;!&ndash; fieldgroups &ndash;&gt;
                                <div ng-repeat="grp in exam.template.fieldgroups">
                                    <h5 class="dl-horizontal" ng-hide="grp.label == ''" ng-model="grp.label"
                                        style="border-bottom: 1px solid black; border-top: 1px solid black;  padding-top: 5px; padding-bottom: 5px">
                                        {{grp.label}}
                                    </h5>
                                    <h5 class="dl-horizontal" ng-show="grp.label == ''" ng-model="grp.label"
                                        style="border-bottom: 1px solid black; padding-top: 5px; padding-bottom: 5px">
                                    </h5>
                                    &lt;!&ndash; fields &ndash;&gt;
                                    <dl class="dl-horizontal">
                    <span class="dl-horizontal" ng-repeat="field in grp.fields">
                      <dt>{{field.label}}</dt>
                      <dd><span ng-repeat="val in field.avalues">{{val.name}}{{$last ? '' : ', '}}</span></dd>
                    </span>
                                    </dl>
                                </div>

                                &lt;!&ndash; exam images &ndash;&gt;
                                <div class="row spacer-top" ng-show="exam.files">
                                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 imgcontainer"
                                         ng-repeat="img in exam.files | filter: {mimetype: 'image/jpeg'} |  orderBy: '_id'">

                                        <img class="img-responsive" src="/routes/files/filereader/{{img.fileid}}"
                                             uib-tooltip="{{img.label}}">
                                        &lt;!&ndash;<img class="img-responsive" src="/routes/files/filereader/{{img.fileid}}"
                                             uib-tooltip="{{img.label}}"
                                             ng-click="celCtrl.editImage(img)">&ndash;&gt;
                                        &lt;!&ndash;<div class="imgcheckbox"><input type="checkbox" ng-model="img.include" ng-click="exam.$save()"></div>&ndash;&gt;
                                    </div>
                                </div>

                                &lt;!&ndash; Befundblock  &ndash;&gt;
                                <h5 class="dl-horizontal"
                                    style="border-bottom: 1px solid black; border-top: 1px solid black; padding-top: 5px; padding-bottom: 5px">
                                    Befund</h5>
                                <dl class="dl-horizontal">
                                    <dt>Diagnose</dt>
                                    <dd><span
                                        ng-repeat="diagnosis in exam.template.diagnosis.avalues">{{diagnosis.name}}{{$last ? '' : ', '}}</span>
                                    </dd>
                                    <dt>Empfehlung</dt>
                                    <dd><span
                                        ng-repeat="diagnosis in exam.template.recommendation.avalues">{{diagnosis.name}}{{$last ? '' : ', '}}</span>
                                    </dd>
                                    <dt>Anmerkung</dt>
                                    <dd><span
                                        ng-repeat="diagnosis in exam.template.comment.avalues">{{diagnosis.name}}{{$last ? '' : ', '}}</span>
                                    </dd>
                                </dl>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            &lt;!&ndash; Bilder block &ndash;&gt;
            <div ng-show="cons.imgs">
                <h4>Bilder aus der Konsultation</h4>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
                     ng-repeat="img in cons.images | filter: {mimetype: 'image/jpeg'} |  orderBy: '_id'">

                    <img class="img-responsive" src="/routes/files/filereader/{{img.fileid}}"
                         ng-click="vm.showImage(img)"
                         uib-tooltip="{{img.label}}">
                </div>
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
                     ng-repeat="video in cons.images | filter: {mimetype: 'video/quicktime'} |  orderBy: '_id'">
                    <video controls class="img-responsive" ng-src="{{video.fileid | trustUrl}}"></video>
                </div>
            </div>
        </div>
    </div>
</uib-accordion>
-->
